import { useLoaderData } from 'remix'
import { shopDetailLists } from '../constants'
import { useState } from 'react';
import { InstagramArticleEmbed } from './InstagramArticleEmbed';
import { InstagramIframe } from './InstagramIframe';
import { ShopContentSwiper } from './modules/ShopContentSwiper'

export const CafePage: React.VFC = ({ processedData }) => {
  const [selectedSection, setSelectedSection] = useState(3);
  //時刻の整形
  const startTime = processedData.shopBusinessHours.business_hours_start
  const endTime = processedData.shopBusinessHours.business_hours_end
  let formattedStartTime = '';
  let formattedEndTime = '';
  if (!processedData.shopBusinessHours.is_closed && startTime !== null) {
    formattedStartTime = startTime.substring(0, 5);
    formattedEndTime = endTime.substring(0, 5);
  }
  const renderSection = () => {
    switch (selectedSection) {
      case 1:
        return <div className='shopDetailText'>{processedData.shopDetails.shop_description}</div>;
      case 2:
        return (
          <div className='recommendPerson'>
            <p>こんな方におすすめ</p>
            <div className='recommendPersonContent'>
              <ul className="recommentLists">
                <li>{processedData.shopDetails.recomend1}</li>
                <li>{processedData.shopDetails.recomend2}</li>
              </ul>
            </div>
          </div>
        );
      case 3:
        return (
          <div className='storeInfo'>
            <p>店舗情報</p>
            <div className='storeInfoDetail'>
              <ul>
                <li>
                  <img width="20" height="25" src={`/icons/sum_address.svg`} />
                  <p>住所 : {processedData.shopDetails.address}</p>
                </li>
                <li>
                  <img width="20" height="25" src={`/icons/sum_hour.svg`} />
                  <p>営業時間 :
                    {processedData.shopBusinessHours.is_closed ? "本日は定休日です" : formattedStartTime + " ~ "} {formattedEndTime}
                  </p>
                </li>
                <li>
                  <img width="20" height="25" src={`/icons/sum_dayoff.svg`} />
                  <p>店休日 : {processedData.shopClosedDays ? processedData.shopClosedDays.join(', ') : '不定休'}</p>
                </li>
                <li>
                  <img width="20" height="25" src={`/icons/sum_phone.svg`} />
                  <p>電話 : {processedData.shopDetails.phone_number}</p>
                </li>
                <li>
                  <img width="20" height="25" src={`/icons/sum_parking.svg`} />
                  <p>駐車場 : {processedData.shopDetails.parking_availability ? "あり" : "なし"}</p>
                </li>
                <li>
                  <img width="20" height="25" src={`/icons/sum_access.svg`} />
                  <p>アクセス : {processedData.shopDetails.nearest_station}</p>
                </li>
                <li>
                  <img width="20" height="25" src={`/icons/sum_hp.svg`} />
                  {processedData.shopDetails.instagram_name ? (
                    <a href={`https://www.instagram.com/${processedData.shopDetails.instagram_name}`} target="_blank" rel="noopener noreferrer">インスタグラムはこちら</a>
                  ) : (
                    <p>インスタグラムはありません</p>
                  )}
                </li>
              </ul>
            </div>
          </div>
        );
      case 4:
        return (
          <div className='hashtag shopDetailText'>
            <ul className='instagramEmbed'>
              {processedData.embeds.map((embeds: any) => (
                <li key={embeds.embed_id}>
                  <InstagramArticleEmbed
                    src={embeds.embed_name}
                  />
                </li>
              ))}
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section className='shopDetailSection'>
      <h1 className="shopName">{processedData.shopDetails.shop_name}</h1>
      <p className='shopSlogan'>{processedData.shopDetails.shop_slogan ? processedData.shopDetails.shop_slogan : ""}</p>
      <p>{processedData.shopDetails.closed ? <p className="shopClosed">閉店</p> : ''}</p>
      {processedData.shopImages.length > 0 ?
        <ShopContentSwiper shopImages={processedData.shopImages} />
        :
        < InstagramIframe src={processedData.shopDetails.instagram_name} />
      }
      <div className='shopDetail'>
        <ul className='shopDetailList'>
          {shopDetailLists.map((shopDetailList) => (
            <li
              key={shopDetailList.id}
              className={selectedSection === shopDetailList.id ? 'selected' : ''}
              onClick={() => setSelectedSection(shopDetailList.id)}
            >
              {shopDetailList.title}
            </li>
          ))}
        </ul>
        {renderSection()}
      </div>
    </section>
  );
};
